import React from 'react';

// The Qate brand mark: a ring with a small triangle tucked inside the
// bottom-right (a "play/run" cue, nothing outside the circle). Uses
// currentColor so it can be tinted per context (white on the dark nav tile,
// ink on light surfaces).
const QateMark = ({ className = '', circleWidth = 4, ...rest }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" aria-hidden="true" {...rest}>
    <circle cx="16" cy="16" r="10.4" stroke="currentColor" strokeWidth={circleWidth} />
    {/* triangle: wide base overlapping the ring stroke (bottom-right) so there's
        no gap, apex pointing inward toward the centre */}
    <path d="M26 20.8 L20.8 26 L17.8 17.8 Z" fill="currentColor" />
  </svg>
);

export default QateMark;
